import {lazy, Suspense, useEffect} from 'react';
/// Components
import Index from './jsx/index';
import {connect, useDispatch} from 'react-redux';
import {Route, Switch, withRouter} from 'react-router-dom';
// action
import {checkAutoLogin} from './services/AuthService';
import {getLoggedInUserData} from './services/UserService';
import {isAuthenticated} from './store/selectors/AuthSelectors';
import NotificationService from './services/NotificationService';
/// Style
import './vendor/bootstrap-select/dist/css/bootstrap-select.min.css';
import './css/style.css';
import './css/notification.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify'

const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => {
    return new Promise(resolve => {
        setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
    });
});
function App(props) {
    const dispatch = useDispatch();
    useEffect(() => {
        checkAutoLogin(dispatch, props.history);
        getLoggedInUserData(dispatch);
        
        // Initialize Firebase Cloud Messaging
        if (props.isAuthenticated) {
            NotificationService.init()
                .then(result => {
                    if (result.success) {
                        console.log('Firebase Cloud Messaging initialized successfully');
                    } else {
                        switch(result.reason) {
                            case 'blocked':
                                console.warn('Notifications are blocked in browser settings');
                                break;
                            case 'denied':
                                console.warn('Notification permission was denied by user');
                                break;
                            case 'unsupported':
                                console.warn('Notifications are not supported in this browser');
                                break;
                            default:
                                console.warn('Failed to initialize Firebase Cloud Messaging:', result.reason);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error initializing Firebase Cloud Messaging:', error);
                });
        }
    }, [dispatch, props.history, props.isAuthenticated]);

    let routes = (
        <Switch>
            <Route path='/login' component={Login} />
            <Route path='/page-register' component={SignUp} />
            <Route path='/page-forgot-password' component={ForgotPassword} />
        </Switch>
    );
    if (props.isAuthenticated) {
        return (
            <>
                <Suspense
                    fallback={
                        <div id='preloader'>
                            <div className='sk-three-bounce'>
                                <div className='sk-child sk-bounce1'></div>
                                <div className='sk-child sk-bounce2'></div>
                                <div className='sk-child sk-bounce3'></div>
                            </div>
                        </div>
                    }
                >
                    <Index />
                    <ToastContainer />
                </Suspense>
            </>
        );
    } else {
        return (
            <div className='vh-100'>
                <Suspense
                    fallback={
                        <div id='preloader'>
                            <div className='sk-three-bounce'>
                                <div className='sk-child sk-bounce1'></div>
                                <div className='sk-child sk-bounce2'></div>
                                <div className='sk-child sk-bounce3'></div>
                            </div>
                        </div>
                    }
                >
                    {routes}
                </Suspense>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App));
